<div class="container-fluid">
  <app-page-header
    icon="fe-mail"
    pretitle="Configurações"
    title="Caixas de e-mail dos módulos"
    description="O endereço por onde entram as participações de cada módulo e de onde saem as respostas."
  >
    <a actions class="btn btn-outline-light" routerLink="..">Voltar</a>
  </app-page-header>
</div>

<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      @if (loading()) {
        <p class="text-muted mb-0">A carregar…</p>
      } @else {
        <div class="table-responsive">
          <table class="table table-sm table-nowrap mb-0">
            <thead>
              <tr>
                <th>Módulo</th>
                <th style="min-width: 18rem">Endereço</th>
                <th style="min-width: 14rem">Para que serve</th>
              </tr>
            </thead>
            <tbody>
              @for (row of rows(); track label(row)) {
                <tr>
                  <td class="fw-bold">{{ label(row) }}</td>
                  <td>
                    <input class="form-control form-control-sm" type="email" [(ngModel)]="row.address"
                           placeholder="caixa@empresa.pt" />
                  </td>
                  <td>
                    <input class="form-control form-control-sm" [(ngModel)]="row.purpose"
                           placeholder="Ex.: reclamações" />
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <p class="text-muted small mt-3 mb-0">
          Deixar o endereço vazio remove a caixa do módulo. O envio e a receção de e-mail entram
          com as Comunicações — por agora, isto é a configuração que elas vão usar.
        </p>
        @if (error()) { <div class="alert alert-danger mt-3 mb-0">{{ error() }}</div> }
        <div class="d-flex justify-content-end mt-3">
          <button class="btn btn-primary" (click)="save()" [disabled]="saving()">
            {{ saving() ? 'A guardar…' : 'Guardar caixas' }}
          </button>
        </div>
      }
    </div>
  </div>
</div>
